import { getLocales } from '../../../locales/Locale';
import Constants, {
  APARTMENT_GROUP,
  AVAILABILITY,
  BUILDING,
} from '../../../utils/Constants';
import { Range } from 'react-range';
import Variables from '../../../style/variables.scss';

const InProgressFilter = ({
  openFilter,
  setOpenFilter,
  filters,
  setFilters,
}: {
  openFilter: boolean;
  setOpenFilter: React.Dispatch<React.SetStateAction<boolean>>;
  filters: {
    area: [number, number];
    building: string | null;
    roomTypes: string[];
    floor: string | null;
    spaceTypes: string[];
    availability: string | null;
  };
  setFilters: React.Dispatch<
    React.SetStateAction<{
      area: [number, number];
      building: string | null;
      roomTypes: string[];
      floor: string | null;
      spaceTypes: string[];
      availability: string | null;
    }>
  >;
}) => {
  const { lang } = getLocales();

  const handleFilterChange = (key: keyof typeof filters, value: any) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: prevFilters[key] === value ? null : value,
    }));
  };

  const handleCheckboxFilterChange = (
    key: 'roomTypes' | 'spaceTypes',
    value: string
  ) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: prevFilters[key].includes(value)
        ? prevFilters[key].filter((v) => v !== value)
        : [...prevFilters[key], value],
    }));
  };

  return (
    <div
      className='inprogress_page_filter'
      style={
        openFilter
          ? { display: 'block', position: 'fixed', top: '0', zIndex: '10' }
          : {}
      }
    >
      <div className='inprogress_page_filter_sticky'>
        <div>
          {openFilter && (
            <div
              className='inprogress_page_filter_close'
              onClick={() => {
                document.body.classList.remove('lock_scroll');
                setOpenFilter(false);
              }}
            >
              {Constants.close(Variables.secondaryColor)}
            </div>
          )}
          <h3>ZGDRADA</h3>
          <div className='inprogress_page_filter_container'>
            <div
              className='opacity_transition_high inprogress_page_filter_container_button'
              onClick={() => handleFilterChange('building', BUILDING.A)}
              style={filters.building === BUILDING.A ? { opacity: 1 } : {}}
            >
              A
            </div>
            <div
              className='opacity_transition_high inprogress_page_filter_container_button'
              onClick={() => handleFilterChange('building', BUILDING.B)}
              style={filters.building === BUILDING.B ? { opacity: 1 } : {}}
            >
              B
            </div>
          </div>
          <h3>BROJ SOBA</h3>
          <div className='inprogress_page_filter_container_column'>
            <label className='checkbox_container'>
              <input
                checked={filters.roomTypes.includes(
                  lang.apartments.name.studio
                )}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'roomTypes',
                    lang.apartments.name.studio
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              GARSONJERA
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.roomTypes.includes(lang.apartments.name.one)}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'roomTypes',
                    lang.apartments.name.one
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              JEDNOSOBNI
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.roomTypes.includes(lang.apartments.name.two)}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'roomTypes',
                    lang.apartments.name.two
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              DVOSOBNI
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.roomTypes.includes(lang.apartments.name.three)}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'roomTypes',
                    lang.apartments.name.three
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              TROSOBNI
            </label>
          </div>
          <h3>VRSTA PROSTORA</h3>
          <div className='inprogress_page_filter_container_column'>
            <label className='checkbox_container'>
              <input
                checked={filters.spaceTypes.includes(APARTMENT_GROUP.BP)}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange('spaceTypes', APARTMENT_GROUP.BP)
                }
              />
              <span className='checkbox_checkmark'></span>
              POSLOVNI
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.spaceTypes.includes(APARTMENT_GROUP.GROUND)}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'spaceTypes',
                    APARTMENT_GROUP.GROUND
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              PRIZEMLJE
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.spaceTypes.includes(APARTMENT_GROUP.FLOOR_ONE)}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'spaceTypes',
                    APARTMENT_GROUP.FLOOR_ONE
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              KAT 1
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.spaceTypes.includes(APARTMENT_GROUP.FLOOR_TWO)}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'spaceTypes',
                    APARTMENT_GROUP.FLOOR_TWO
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              KAT 2
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.spaceTypes.includes(
                  APARTMENT_GROUP.FLOOR_THREE
                )}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'spaceTypes',
                    APARTMENT_GROUP.FLOOR_THREE
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              KAT 3
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.spaceTypes.includes(
                  APARTMENT_GROUP.FLOOR_FOUR
                )}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'spaceTypes',
                    APARTMENT_GROUP.FLOOR_FOUR
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              KAT 4
            </label>
            <label className='checkbox_container'>
              <input
                checked={filters.spaceTypes.includes(
                  APARTMENT_GROUP.SUPERSTRUCTURE
                )}
                type='checkbox'
                onChange={() =>
                  handleCheckboxFilterChange(
                    'spaceTypes',
                    APARTMENT_GROUP.SUPERSTRUCTURE
                  )
                }
              />
              <span className='checkbox_checkmark'></span>
              NADGRAĐE
            </label>
          </div>
          <h3>RASPOLOŽIVOST</h3>
          <div className='inprogress_page_filter_container'>
            <select
              onChange={(e) =>
                handleFilterChange('availability', e.target.value)
              }
            >
              <option value='0'>---</option>
              <option value={AVAILABILITY.FREE}>Slobodno</option>
              <option value={AVAILABILITY.RESERVED}>Rezervirano</option>
              <option value={AVAILABILITY.SOLD}>Prodano</option>
            </select>
          </div>
          <h3>POVRŠINA</h3>
          <div className='inprogress_page_filter_container_row'>
            <Range
              label='Select your value'
              step={0.1}
              min={19}
              max={80}
              values={filters.area}
              rtl={false}
              onChange={(values) =>
                handleFilterChange('area', values as [number, number])
              }
              renderTrack={({ props, children }) => (
                <div
                  {...props}
                  style={{
                    ...props.style,
                    height: '6px',
                    width: '100%',
                    backgroundColor: '#ccc',
                  }}
                >
                  {children}
                </div>
              )}
              renderThumb={({ props, isDragged }) => (
                <div
                  {...props}
                  key={props.key}
                  style={{
                    ...props.style,
                    height: '24px',
                    width: '24px',
                    borderRadius: '4px',
                    backgroundColor: '#FFF',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0px 2px 6px #AAA',
                  }}
                >
                  <div
                    style={{
                      height: '8px',
                      width: '2px',
                      backgroundColor: isDragged ? '#548BF4' : '#CCC',
                    }}
                  />
                </div>
              )}
            />
            <output
              style={{
                display: 'flex',
                width: '100%',
                marginTop: '30px',
                justifyContent: 'space-between',
              }}
              id='output'
            >
              <div>{filters.area[0].toFixed(0)} m2</div>
              <div>{filters.area[1].toFixed(0)} m2</div>
            </output>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InProgressFilter;
